// import { db } from '../firebase'; // Firebase not used, removing import
// import { doc, getDoc, setDoc } from 'firebase/firestore';

// Mocking Firestore for now since Firebase isn't set up
const mockDb: Record<string, any> = {};

export const getContent = async (slug: string) => {
  try {
    return mockDb[slug] || '';
  } catch (error) {
    console.error('Error fetching content:', error);
    return '';
  }
};

export const updateContent = async (slug: string, content: string) => {
  try {
    mockDb[slug] = content;
    console.log(`Content updated for ${slug}`);
  } catch (error) {
    console.error('Error updating content:', error);
    throw error;
  }
};
